/* tslint:disable */
/* eslint-disable */
/**
 * Subscription App API
 * Provides management of all subscription operations at subscription app tier.
 *
 * The version of the OpenAPI document: 1.11.5
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AmwayUser } from './AmwayUser';
import {
    AmwayUserFromJSON,
    AmwayUserFromJSONTyped,
    AmwayUserToJSON,
} from './AmwayUser';
import type { DeliveryOption } from './DeliveryOption';
import {
    DeliveryOptionFromJSON,
    DeliveryOptionFromJSONTyped,
    DeliveryOptionToJSON,
} from './DeliveryOption';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';
import type { OrderHistory } from './OrderHistory';
import {
    OrderHistoryFromJSON,
    OrderHistoryFromJSONTyped,
    OrderHistoryToJSON,
} from './OrderHistory';
import type { Payment } from './Payment';
import {
    PaymentFromJSON,
    PaymentFromJSONTyped,
    PaymentToJSON,
} from './Payment';
import type { PlanResponse } from './PlanResponse';
import {
    PlanResponseFromJSON,
    PlanResponseFromJSONTyped,
    PlanResponseToJSON,
} from './PlanResponse';
import type { ProductData } from './ProductData';
import {
    ProductDataFromJSON,
    ProductDataFromJSONTyped,
    ProductDataToJSON,
} from './ProductData';
import type { ProfileResponse } from './ProfileResponse';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './ProfileResponse';
import type { SubscriptionElement } from './SubscriptionElement';
import {
    SubscriptionElementFromJSON,
    SubscriptionElementFromJSONTyped,
    SubscriptionElementToJSON,
} from './SubscriptionElement';
import type { SubscriptionProductEntry } from './SubscriptionProductEntry';
import {
    SubscriptionProductEntryFromJSON,
    SubscriptionProductEntryFromJSONTyped,
    SubscriptionProductEntryToJSON,
} from './SubscriptionProductEntry';
import type { SubscriptionType } from './SubscriptionType';
import {
    SubscriptionTypeFromJSON,
    SubscriptionTypeFromJSONTyped,
    SubscriptionTypeToJSON,
} from './SubscriptionType';
import type { UserChoiceBenefit } from './UserChoiceBenefit';
import {
    UserChoiceBenefitFromJSON,
    UserChoiceBenefitFromJSONTyped,
    UserChoiceBenefitToJSON,
} from './UserChoiceBenefit';

/**
 * 
 * @export
 * @interface SubscriptionResponse
 */
export interface SubscriptionResponse {
    /**
     * identifier of the subscription
     * @type {string}
     * @memberof SubscriptionResponse
     */
    id: string;
    /**
     * 
     * @type {AmwayUser}
     * @memberof SubscriptionResponse
     */
    amwayUser?: AmwayUser;
    /**
     * subscription Amount
     * @type {string}
     * @memberof SubscriptionResponse
     */
    subscribeAmount?: string;
    /**
     * parent account id who will create a subscription for it's down line user
     * @type {string}
     * @memberof SubscriptionResponse
     */
    parentAccountId?: string;
    /**
     * 
     * @type {AmwayUser}
     * @memberof SubscriptionResponse
     */
    parentAmwayUser?: AmwayUser;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    isDownline?: boolean;
    /**
     * 
     * @type {SubscriptionType}
     * @memberof SubscriptionResponse
     */
    type?: SubscriptionType;
    /**
     * unique code of subscription
     * @type {string}
     * @memberof SubscriptionResponse
     */
    code?: string;
    /**
     * 
     * @type {DeliveryOption}
     * @memberof SubscriptionResponse
     */
    deliveryOption?: DeliveryOption;
    /**
     * 
     * @type {Array<SubscriptionProductEntry>}
     * @memberof SubscriptionResponse
     */
    entries?: Array<SubscriptionProductEntry>;
    /**
     * Formatted Price including currency symbol
     * @type {string}
     * @memberof SubscriptionResponse
     */
    formattedPrice?: string;
    /**
     * DRAFT, PENDING, ACTIVE, CANCELLED, PAUSED, COMPLETED
     * @type {string}
     * @memberof SubscriptionResponse
     */
    status?: SubscriptionResponseStatusEnum;
    /**
     * planStartDate
     * @type {Date}
     * @memberof SubscriptionResponse
     */
    startDate?: Date;
    /**
     * 
     * @type {ProfileResponse}
     * @memberof SubscriptionResponse
     */
    profile?: ProfileResponse;
    /**
     * 
     * @type {Payment}
     * @memberof SubscriptionResponse
     */
    payment?: Payment;
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof SubscriptionResponse
     */
    products?: Array<ProductData>;
    /**
     * 
     * @type {Array<OrderHistory>}
     * @memberof SubscriptionResponse
     */
    orderHistory?: Array<OrderHistory>;
    /**
     * 
     * @type {Array<SubscriptionElement>}
     * @memberof SubscriptionResponse
     */
    elements?: Array<SubscriptionElement>;
    /**
     * 
     * @type {Array<SubscriptionElement>}
     * @memberof SubscriptionResponse
     */
    currentElements?: Array<SubscriptionElement>;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    allowChangeProductVariant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    allowChangeProducts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    allowSwitching?: boolean;
    /**
     * 
     * @type {PlanResponse}
     * @memberof SubscriptionResponse
     */
    plan?: PlanResponse;
    /**
     * total number of cycles in fix plan for infinite plan value would be 0
     * @type {number}
     * @memberof SubscriptionResponse
     */
    totalCycles?: number;
    /**
     * current cycle number
     * @type {number}
     * @memberof SubscriptionResponse
     */
    currentCycle?: number;
    /**
     * total completed cycles count
     * @type {number}
     * @memberof SubscriptionResponse
     */
    completedCycles?: number;
    /**
     * current cycle's total shipments with limit for fixed plan and current cycle total shipment for infinite plan
     * @type {number}
     * @memberof SubscriptionResponse
     */
    currentCycleTotalShipments?: number;
    /**
     * current cycle's completed shipments total include all for fixed plan and current cycle completed shipment for infinite plan
     * @type {number}
     * @memberof SubscriptionResponse
     */
    currentCycleCompletedShipments?: number;
    /**
     * total shipments
     * @type {number}
     * @memberof SubscriptionResponse
     */
    totalShipments?: number;
    /**
     * current cycle start month
     * @type {number}
     * @memberof SubscriptionResponse
     */
    currentCycleStartMonth?: number;
    /**
     * current cycle start year
     * @type {number}
     * @memberof SubscriptionResponse
     */
    currentCycleStartYear?: number;
    /**
     * completed shipments
     * @type {number}
     * @memberof SubscriptionResponse
     */
    completedShipments?: number;
    /**
     * next payment date for next shipment
     * @type {Date}
     * @memberof SubscriptionResponse
     */
    nextPaymentDate?: Date;
    /**
     * process day of shipment
     * @type {number}
     * @memberof SubscriptionResponse
     */
    processDay?: number;
    /**
     * 
     * @type {Metadata}
     * @memberof SubscriptionResponse
     */
    metadata?: Metadata;
    /**
     * version
     * @type {number}
     * @memberof SubscriptionResponse
     */
    version: number;
    /**
     * PAYMENT_FAILED, USER_PAUSED, USER_CANCELLED, AUTO_CANCELLED, BO_CANCELLED, PROFILE_INACTIVATED, PROFILE_PENDING, PROFILE_CANCELLED
     * @type {string}
     * @memberof SubscriptionResponse
     */
    subStatus?: SubscriptionResponseSubStatusEnum;
    /**
     * PENDING, ACTIVE, CANCELLED, PAUSED, COMPLETED
     * @type {string}
     * @memberof SubscriptionResponse
     */
    displayStatus?: SubscriptionResponseDisplayStatusEnum;
    /**
     * 
     * @type {Array<UserChoiceBenefit>}
     * @memberof SubscriptionResponse
     */
    userChoiceBenefit?: Array<UserChoiceBenefit>;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    executeToday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    displayExecuteToday?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionResponse
     */
    executeTodayDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    autoContinue?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionResponse
     */
    allowAutoContinue?: boolean;
}


/**
 * @export
 */
export const SubscriptionResponseStatusEnum = {
    Draft: 'DRAFT',
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Cancelled: 'CANCELLED',
    Paused: 'PAUSED',
    Completed: 'COMPLETED'
} as const;
export type SubscriptionResponseStatusEnum = typeof SubscriptionResponseStatusEnum[keyof typeof SubscriptionResponseStatusEnum];

/**
 * @export
 */
export const SubscriptionResponseSubStatusEnum = {
    PaymentFailed: 'PAYMENT_FAILED',
    UserPaused: 'USER_PAUSED',
    UserCancelled: 'USER_CANCELLED',
    AutoCancelled: 'AUTO_CANCELLED',
    BoCancelled: 'BO_CANCELLED',
    ProfileInactivated: 'PROFILE_INACTIVATED',
    ProfilePending: 'PROFILE_PENDING',
    ProfileCancelled: 'PROFILE_CANCELLED'
} as const;
export type SubscriptionResponseSubStatusEnum = typeof SubscriptionResponseSubStatusEnum[keyof typeof SubscriptionResponseSubStatusEnum];

/**
 * @export
 */
export const SubscriptionResponseDisplayStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Cancelled: 'CANCELLED',
    Paused: 'PAUSED',
    Completed: 'COMPLETED'
} as const;
export type SubscriptionResponseDisplayStatusEnum = typeof SubscriptionResponseDisplayStatusEnum[keyof typeof SubscriptionResponseDisplayStatusEnum];


/**
 * Check if a given object implements the SubscriptionResponse interface.
 */
export function instanceOfSubscriptionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function SubscriptionResponseFromJSON(json: any): SubscriptionResponse {
    return SubscriptionResponseFromJSONTyped(json, false);
}

export function SubscriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amwayUser': !exists(json, 'amwayUser') ? undefined : AmwayUserFromJSON(json['amwayUser']),
        'subscribeAmount': !exists(json, 'subscribeAmount') ? undefined : json['subscribeAmount'],
        'parentAccountId': !exists(json, 'parentAccountId') ? undefined : json['parentAccountId'],
        'parentAmwayUser': !exists(json, 'parentAmwayUser') ? undefined : AmwayUserFromJSON(json['parentAmwayUser']),
        'isDownline': !exists(json, 'isDownline') ? undefined : json['isDownline'],
        'type': !exists(json, 'type') ? undefined : SubscriptionTypeFromJSON(json['type']),
        'code': !exists(json, 'code') ? undefined : json['code'],
        'deliveryOption': !exists(json, 'deliveryOption') ? undefined : DeliveryOptionFromJSON(json['deliveryOption']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(SubscriptionProductEntryFromJSON)),
        'formattedPrice': !exists(json, 'formattedPrice') ? undefined : json['formattedPrice'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'profile': !exists(json, 'profile') ? undefined : ProfileResponseFromJSON(json['profile']),
        'payment': !exists(json, 'payment') ? undefined : PaymentFromJSON(json['payment']),
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(ProductDataFromJSON)),
        'orderHistory': !exists(json, 'orderHistory') ? undefined : ((json['orderHistory'] as Array<any>).map(OrderHistoryFromJSON)),
        'elements': !exists(json, 'elements') ? undefined : ((json['elements'] as Array<any>).map(SubscriptionElementFromJSON)),
        'currentElements': !exists(json, 'currentElements') ? undefined : ((json['currentElements'] as Array<any>).map(SubscriptionElementFromJSON)),
        'allowChangeProductVariant': !exists(json, 'allowChangeProductVariant') ? undefined : json['allowChangeProductVariant'],
        'allowChangeProducts': !exists(json, 'allowChangeProducts') ? undefined : json['allowChangeProducts'],
        'allowSwitching': !exists(json, 'allowSwitching') ? undefined : json['allowSwitching'],
        'plan': !exists(json, 'plan') ? undefined : PlanResponseFromJSON(json['plan']),
        'totalCycles': !exists(json, 'totalCycles') ? undefined : json['totalCycles'],
        'currentCycle': !exists(json, 'currentCycle') ? undefined : json['currentCycle'],
        'completedCycles': !exists(json, 'completedCycles') ? undefined : json['completedCycles'],
        'currentCycleTotalShipments': !exists(json, 'currentCycleTotalShipments') ? undefined : json['currentCycleTotalShipments'],
        'currentCycleCompletedShipments': !exists(json, 'currentCycleCompletedShipments') ? undefined : json['currentCycleCompletedShipments'],
        'totalShipments': !exists(json, 'totalShipments') ? undefined : json['totalShipments'],
        'currentCycleStartMonth': !exists(json, 'currentCycleStartMonth') ? undefined : json['currentCycleStartMonth'],
        'currentCycleStartYear': !exists(json, 'currentCycleStartYear') ? undefined : json['currentCycleStartYear'],
        'completedShipments': !exists(json, 'completedShipments') ? undefined : json['completedShipments'],
        'nextPaymentDate': !exists(json, 'nextPaymentDate') ? undefined : (new Date(json['nextPaymentDate'])),
        'processDay': !exists(json, 'processDay') ? undefined : json['processDay'],
        'metadata': !exists(json, 'metadata') ? undefined : MetadataFromJSON(json['metadata']),
        'version': json['version'],
        'subStatus': !exists(json, 'subStatus') ? undefined : json['subStatus'],
        'displayStatus': !exists(json, 'displayStatus') ? undefined : json['displayStatus'],
        'userChoiceBenefit': !exists(json, 'userChoiceBenefit') ? undefined : ((json['userChoiceBenefit'] as Array<any>).map(UserChoiceBenefitFromJSON)),
        'executeToday': !exists(json, 'executeToday') ? undefined : json['executeToday'],
        'displayExecuteToday': !exists(json, 'displayExecuteToday') ? undefined : json['displayExecuteToday'],
        'executeTodayDate': !exists(json, 'executeTodayDate') ? undefined : (new Date(json['executeTodayDate'])),
        'autoContinue': !exists(json, 'autoContinue') ? undefined : json['autoContinue'],
        'allowAutoContinue': !exists(json, 'allowAutoContinue') ? undefined : json['allowAutoContinue'],
    };
}

export function SubscriptionResponseToJSON(value?: SubscriptionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'amwayUser': AmwayUserToJSON(value.amwayUser),
        'subscribeAmount': value.subscribeAmount,
        'parentAccountId': value.parentAccountId,
        'parentAmwayUser': AmwayUserToJSON(value.parentAmwayUser),
        'isDownline': value.isDownline,
        'type': SubscriptionTypeToJSON(value.type),
        'code': value.code,
        'deliveryOption': DeliveryOptionToJSON(value.deliveryOption),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(SubscriptionProductEntryToJSON)),
        'formattedPrice': value.formattedPrice,
        'status': value.status,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0,10)),
        'profile': ProfileResponseToJSON(value.profile),
        'payment': PaymentToJSON(value.payment),
        'products': value.products === undefined ? undefined : ((value.products as Array<any>).map(ProductDataToJSON)),
        'orderHistory': value.orderHistory === undefined ? undefined : ((value.orderHistory as Array<any>).map(OrderHistoryToJSON)),
        'elements': value.elements === undefined ? undefined : ((value.elements as Array<any>).map(SubscriptionElementToJSON)),
        'currentElements': value.currentElements === undefined ? undefined : ((value.currentElements as Array<any>).map(SubscriptionElementToJSON)),
        'allowChangeProductVariant': value.allowChangeProductVariant,
        'allowChangeProducts': value.allowChangeProducts,
        'allowSwitching': value.allowSwitching,
        'plan': PlanResponseToJSON(value.plan),
        'totalCycles': value.totalCycles,
        'currentCycle': value.currentCycle,
        'completedCycles': value.completedCycles,
        'currentCycleTotalShipments': value.currentCycleTotalShipments,
        'currentCycleCompletedShipments': value.currentCycleCompletedShipments,
        'totalShipments': value.totalShipments,
        'currentCycleStartMonth': value.currentCycleStartMonth,
        'currentCycleStartYear': value.currentCycleStartYear,
        'completedShipments': value.completedShipments,
        'nextPaymentDate': value.nextPaymentDate === undefined ? undefined : (value.nextPaymentDate.toISOString().substr(0,10)),
        'processDay': value.processDay,
        'metadata': MetadataToJSON(value.metadata),
        'version': value.version,
        'subStatus': value.subStatus,
        'displayStatus': value.displayStatus,
        'userChoiceBenefit': value.userChoiceBenefit === undefined ? undefined : ((value.userChoiceBenefit as Array<any>).map(UserChoiceBenefitToJSON)),
        'executeToday': value.executeToday,
        'displayExecuteToday': value.displayExecuteToday,
        'executeTodayDate': value.executeTodayDate === undefined ? undefined : (value.executeTodayDate.toISOString().substr(0,10)),
        'autoContinue': value.autoContinue,
        'allowAutoContinue': value.allowAutoContinue,
    };
}

